import React from "react"
  import {
    Container,
    Col,
    Row, CardHeader, Collapse, CardBody, Card} from 'reactstrap';
    import {isMobile} from 'react-device-detect';
    import Database from "./database/Database"
    import { Waypoint } from 'react-waypoint';
    
    class Part3 extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                mobile:isMobile,
                count:0,
            }
          }
            handleFlourish() {
                this.setState(prevState => {
                    return {
                        count: 1
                    }
                })
            }

        render()
        {
            let flourishembed= this.state.count===1? <div><iframe src='https://public.flourish.studio/visualisation/1711437/embed' title="title8" frameBorder='0' scrolling='no' style={{width:"100%",height:"650px"}}></iframe><div className="text-right"><a href="https://flourish.studio/?utm_source=embed" target='_top'><img alt="Made with Flourish" src="https://public.flourish.studio/resources/made_with_flourish.svg"/></a></div></div> : <p>&nbsp;</p>
            return (
                <div>
                <Container fluid><h2 className="text-center newsection"><span className="display-2 home-4">PART FOUR</span></h2>
                </Container>
                    <Container id="howquickly" fluid>
                        <Container>
                            <Row className="justify-content-center align-items-center">
                                <Col lg="10" xs="12" className="text-left no-padding">
                                    <p className="display-2 aliagray home-2 text-center">
                                    How quickly has the virus spread around the world?
                                    </p>
                                    <p>
                                    The first reported coronavirus case was a 55-year-old individual from Hubei province, China, on November 17, 2019.
                                    </p>
                                    <p>
                                    The virus quickly spread around the region and then the world. On March 26, the US overtook China and currently has the highest number of confirmed cases worldwide.
                                    </p>
                                    <p>
                                    The animation below shows how the virus spread globally.
                                    </p>
                                    <Waypoint onEnter={()=> {this.handleFlourish()}}/>  
                                    {flourishembed}
                                    <p><em><a href ="https://public.flourish.studio/visualisation/1711437/" target="_blank" rel="noopener noreferrer">SHARE THIS GRAPHIC</a></em></p>
                                    <div>
                                </div>
                                </Col>
                            </Row>

                        </Container>
                    </Container>
                </div>
            )
        }
    }
    export default Part3